export default __webpack_public_path__ + "static/media/0013.21a4b130.jpg";